import * as UAParser from 'ua-parser-js';

const browserDetect = new UAParser();
const CURRENT_BROWSER = browserDetect.getBrowser();

function browserIs(options) {
  const evaluate = ([key, operation]) => {
    const referenceValue = CURRENT_BROWSER[key];

    if (typeof operation === 'function') return operation(referenceValue);

    return operation === referenceValue;
  };

  const results = Object.entries(options).map(evaluate);
  return results.every(Boolean);
}

export function browserUnsupported() {
  if (browserDetect.getDevice().type === 'mobile') return false;

  const isIE = browserIs({ name: 'IE' });

  return isIE;
}
